export const HanreiColorpallet = ({ color }) => {
  return (
    <>
      <div className="cursor-pointer pointer-events-auto hover:bg-gray-300 rounded-xl">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="50 15 65 50"
          fontFamily='"Helvetica Neue",
              Arial,
              "Hiragino Kaku Gothic ProN",
              "Hiragino Sans",
              Meiryo,
              sans-serif;'
        >
          <g id="参考" display="none"></g>
          <g id="背景の白色">
            {/* <rect x="0" y="0" opacity="0.75" fill="#FFFFFF" width="165" height="85"/> */}
          </g>

          <g
            id="bar1"
            type="color"
            // onChange={e => document.getElementById("bar1Picker").click()}
            // onClick={pickerClicker1}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={color[1]}
              // className={`hover:fill-red-500`}
              // className={`fill-[${"#e51400"}] hover:fill-blue-500`}
              points="104.231,14.064 91.565,15.231 81.899,58.564 84.065,60.064 89.565,60.23 114.731,18.897"
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="114.565,19.231 100.899,19.397 91.732,15.564 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="84.399"
              y1="60.23"
              x2="100.899"
              y2="19.397"
            />
          </g>
          <g
            id="bar2"
            type="color"
            //  onClick={pickerClicker2}
            pointerEvents="fill"
            className="svg-bars"
          >
            {/* <g id="オレンジ棒"> */}
            <polygon
              fill={color[2]}
              points="89.065,31.731 84.233,27.731 73.733,28.064 73.565,60.064 76.899,61.896 82.065,60.896 	"
            />
            <path fill="none" d="M90.399,81.064" />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="88.774,31.897 78.565,32.73 73.815,28.314 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="76.733"
              y1="61.73"
              x2="78.565"
              y2="32.73"
            />
          </g>
          {/* <g id="黄色い棒"> */}
          <g
            id="bar3"
            type="color"
            //  onClick={pickerClicker3}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={color[3]}
              points="74.399,46.397 70.399,41.064 61.399,42.73 63.899,59.23 67.233,62.064 72.899,60.396 "
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="61.733,42.897 66.565,47.897 74.065,46.522 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="67.233"
              y1="62.064"
              x2="66.565"
              y2="47.897"
            />
          </g>
          {/* <g id="灰色の棒"> */}
          <g
            id="bar4"
            type="color"
            //  onClick={pickerClicker4}
            pointerEvents="fill"
            className="svg-bars"
          >
            <polygon
              fill={color[4]}
              points="63.903,51.641 59.919,48.961 53.521,51.97 58.485,62.356 61.505,63.524 65.415,61.22 "
            />
            <polyline
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="53.901,52.085 58.409,54.354 63.702,51.875 "
            />
            <line
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="0.75"
              strokeLinecap="round"
              strokeMiterlimit="10"
              x1="61.546"
              y1="63.512"
              x2="58.409"
              y2="54.354"
            />
          </g>
        </svg>
        <div>{color[0]}</div>
      </div>

      <></>
    </>
  );
};
